<template>
  <div
    id="panel"
    class="panel"
    style="min-width: 950px;"
  >
    <div class="panel-title">
      <p>基本信息</p>
    </div>
    <div class="panel-content center_content">
      <div id="searchSection">
        <div
          id="center"
          style="min-height: 677px;"
        >
          <div
            id="content"
            class="content"
            style=""
          >
            <div
              class="center_content container"
              style="width:100%;visibility: visible;"
            >
              <div class="box-wrap mbox clearfix">
                <div class="lBox">
                  <div class="title">
                    <p class="title_text">{{ formInfo.title }}</p>
                    <div class="title-btns"><a
                        class="edit"
                        @click="openBrief"
                        v-if="formInfo.status==0"
                      ><i class="icon iconfont">&#xe660;</i>编辑</a></div>
                  </div>
                  <div class="detail">
                    <div class="item">
                      <p>负责人：<span>{{formInfo.manager_id?formInfo.manager.name:'-'}}</span></p>
                      <p>学期：<span>{{ formatTerm(formInfo.term) }}</span></p>
                    </div>
                    <div class="item">
                      <p>授课语种：{{formInfo.lessonLang?$store.state.dict_basic_Lang[formInfo.lessonLang]:'-'}}</p>
                      <p>对应专业大类：{{formInfo.subject?formInfo.subject.subject_category.title:'-'}}</p>
                      <p>对应专业：{{formInfo.subject?formInfo.subject.title:'-'}}</p>
                    </div>
                    <div
                      class="item"
                      v-show="formInfo"
                    >
                      <p v-show="formInfo.startTime">开课时间： {{$formatDate(formInfo.startTime)}} 至 {{$formatDate(formInfo.endTime)}}</p>
                    </div>
                    <div class="item">
                      <p>课程对象：
                        <template v-if="formInfo.lessonObj.Obj1">本科生 </template>
                        <template v-if="formInfo.lessonObj.Obj2">专科生 </template>
                        <template v-if="formInfo.lessonObj.Obj3">社会学者</template>
                        <template v-if="formInfo.lessonObj.Obj1 =='' && formInfo.lessonObj.Obj2=='' && formInfo.lessonObj.Obj3==''">-</template>
                      </p>
                      <p>课程性质：
                        <template v-if="formInfo.lessonObj.Obj4">高校学分认定课 </template>
                        <template v-if="formInfo.lessonObj.Obj5">社会学习者课程 </template>
                        <template v-if="formInfo.lessonObj.Obj4 =='' && formInfo.lessonObj.Obj5==''">-</template>
                      </p>
                    </div>
                    <div class="item">
                      <p class="des">课程简介：<template v-if="formInfo.recommend">{{formInfo.recommend}}</template><template v-else>-</template></p>
                    </div>
                  </div>
                </div>
                <div class="rBox">
                  <div class="title titleA">
                    <div class="title-btns">
                      <router-link
                        :to="'/www/lesson_detail?id=' + formInfo.id"
                        class="preview"
                      >预览</router-link>
                      <a
                        v-if="formInfo.status==0"
                        class="submit"
                        href="javascript:;"
                        @click="$parent.saveOnline(formInfo.title, formInfo.id)"
                      >提交审核</a>
                    </div>
                  </div>
                  <div class="imgCover">
                    <img
                      :src="formInfo.logoPath?formInfo.logoPath:'--' "
                      :onerror="$store.state.defaultImg"
                    >
                  </div>
                  <div
                    class="upload"
                    @click="openProPic"
                  >上传题图</div>
                </div>
              </div>
              <div
                class="part-item projectRecord"
                style="margin-top:20px;"
              >
                <p class="part-title">课程简介及课程特色
                  <a
                    href="javascript:;"
                    @click="clearItem('brief')"
                    v-if="formInfo.status==0"
                  ><i class="icon iconfont">&#xe614;</i>清空</a>
                  <a
                    href="javascript:;"
                    @click="showBrief2"
                    v-if="formInfo.status==0"
                  ><i class="icon iconfont">&#xe660;</i>编辑</a>
                </p>
                <div
                  v-if="formInfo.brief"
                  class="part-content"
                  v-html="formInfo.brief"
                ></div>
                <div
                  v-else
                  class="part-content"
                >暂无内容，请进行维护</div>
              </div>
              <div class="part-item projectRecord">
                <p class="part-title">参考资料
                  <a
                    href="javascript:;"
                    @click="clearItem('references')"
                    v-if="formInfo.status==0"
                  ><i class="icon iconfont">&#xe614;</i>清空</a>
                  <a
                    href="javascript:;"
                    @click="showReferences"
                    v-if="formInfo.status==0"
                  ><i class="icon iconfont">&#xe660;</i>编辑</a>
                </p>
                <div
                  v-if="formInfo.references"
                  class="part-content"
                  v-html="formInfo.references"
                ></div>
                <div
                  v-else
                  class="part-content"
                >暂无内容，请进行维护</div>
              </div>
              <div class="part-item projectRecord">
                <p class="part-title">常见问题
                  <a
                    href="javascript:;"
                    @click="clearItem('questions')"
                    v-if="formInfo.status==0"
                  ><i class="icon iconfont">&#xe614;</i>清空</a>
                  <a
                    href="javascript:;"
                    @click="showQuestions"
                    v-if="formInfo.status==0"
                  ><i class="icon iconfont">&#xe660;</i>编辑</a>
                </p>
                <div
                  v-if="formInfo.questions"
                  class="part-content"
                  v-html="formInfo.questions"
                ></div>
                <div
                  v-else
                  class="part-content"
                >暂无内容，请进行维护</div>
              </div>
            </div>
            <div
              class="form_overlay"
              id="brief_overlay"
              style="z-index: 2;"
              :style="formatShowWindow(showWindow.brief)"
            >
              <div class="form_overlay_bg"></div>
              <div class="form_panel">
                <div class="form_title">课程编辑</div>
                <a
                  href="javascript:void(0)"
                  class="overlay-close"
                  @click="showWindow.brief = false"
                ><i class="iconfont">&#xe605;</i></a>
                <div class="form_content">
                  <form id="briefForm">
                    <div class="item">
                      <span class="label"><i class="require">*</i>课程名称</span>
                      <input
                        type="text"
                        v-model="formInfo.title"
                        class="form-control"
                        disabled="disabled"
                      >
                    </div>
                    <div class="item">
                      <span class="label"><i class="require">*</i>公开课程</span>
                      <input
                        type="radio"
                        value="1"
                        @change="showRadio(formBrief.isPub)"
                        v-model="formBrief.isPub"
                        style="margin-right: 0px"
                      />
                      是
                      <input
                        type="radio"
                        value="0"
                        @change="showRadio(formBrief.isPub)"
                        v-model="formBrief.isPub"
                        style="margin-right: 0px; margin-left: 20px"
                      />
                      否
                    </div>
                    <div class="item">
                      <span class="label"><i class="require">*</i>授课语种</span>
                      <select v-model="formBrief.lessonLang">
                        <option value="0">请选择</option>
                        <option value="1">中文</option>
                        <option value="2">英文</option>
                        <option value="3">双语</option>
                        <option value="4">其他</option>
                      </select>
                    </div>
                    <div class="item">
                      <span class="label"><i class="require">*</i>所属专业大类</span>
                      <select
                        @change="getSubject(formBrief.subjectCategory_id)"
                        v-model="formBrief.subjectCategory_id"
                      >
                        <option value=''>请选择</option>
                        <option
                          :value="item.id"
                          v-for="item in categoryData"
                          :key="item.id"
                        >{{item.title}}</option>
                      </select>
                    </div>
                    <div class="item">
                      <span class="label"><i class="require">*</i>所属专业</span>
                      <select v-model="formBrief.subject_id">
                        <option value=''>请选择</option>
                        <option
                          :value="item.id"
                          v-for="item in subjectData"
                          :key="item.id"
                        >{{item.title}}</option>
                      </select>
                    </div>
                    <div class="item">
                      <span class="label">适用其他专业</span>
                      <div class="item-input">
                        <div
                          v-for="(itme, index) in formBrief.otherSubject"
                          :key="index"
                        >
                          <input
                            type="text"
                            v-model="itme.txt"
                            style="width:285px"
                            class="form-control"
                          >
                          <span
                            class="del"
                            @click="delOtherSubject(index)"
                          >x</span>
                        </div>
                      </div>
                      <div
                        class="addBtn"
                        @click="addOtherSubject"
                      >添加一个</div>
                    </div>
                    <div class="item">
                      <span class="label">课程对象</span>
                      <div>
                        <div class="wrap"><label><input
                              type="checkbox"
                              v-model="formBrief.lessonObj.Obj1"
                            />本科生课程</label></div>
                        <div class="wrap"><label><input
                              type="checkbox"
                              v-model="formBrief.lessonObj.Obj2"
                            />专科生课程</label></div>
                        <div class="wrap"><label><input
                              type="checkbox"
                              v-model="formBrief.lessonObj.Obj3"
                            />社会学习者</label></div>
                      </div>
                    </div>
                    <div class="item">
                      <span class="label">课程性质</span>
                      <div>
                        <div class="wrap"><label><input
                              type="checkbox"
                              v-model="formBrief.lessonObj.Obj4"
                            />高校学分认定课</label></div>
                        <div class="wrap"><label><input
                              type="checkbox"
                              v-model="formBrief.lessonObj.Obj5"
                            />社会学习者课程</label></div>
                      </div>
                    </div>
                    <div class="item">
                      <span class="label"><i class="require">*</i>总学时(周)</span>
                      <input
                        type="number"
                        v-model="formBrief.allTime"
                        placeholder="请输入总学时"
                        class="form-control"
                        maxlength="10"
                      >
                    </div>
                    <div class="item">
                      <span class="label"><i class="require">*</i>开始时间</span>
                      <input
                        type="date"
                        v-model="formBrief.startTime"
                        class="date"
                      >
                    </div>
                    <div class="item">
                      <span class="label"><i class="require">*</i>结束时间</span>
                      <input
                        type="date"
                        v-model="formBrief.endTime"
                        class="date"
                      >
                    </div>
                    <div class="item">
                      <span class="label"><i class="require">*</i>学分</span>
                      <input
                        type="number"
                        v-model="formBrief.grade"
                        class="form-control"
                        maxlength="10"
                      >
                    </div>
                    <div class="item">
                      <span class="label">课程简介</span>
                      <div class="tips">
                        <textarea
                          rows="3"
                          maxlength="200"
                          v-model="formBrief.recommend"
                          placeholder="请输入课程推荐词"
                        ></textarea>
                        <span>还可以输入{{formatNum(200,formBrief.recommend)}}字</span>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="form_control">
                  <a
                    href="javascript:;"
                    @click="showWindow.brief = false"
                    class="button close"
                    id="brief_close"
                  >取消</a>
                  <a
                    href="javascript:;"
                    @click="saveBrief"
                    class="button"
                    id="brief_submit"
                  >提交</a>
                </div>
              </div>
            </div>
            <div
              class="form_overlay"
              id="proPic_overlay"
              :style="formatShowWindow(showWindow.proPic)"
            >
              <div class="form_overlay_bg"></div>
              <div class="form_panel">
                <div class="form_title">编辑课程图片</div>
                <a
                  href="javascript:void(0)"
                  class="overlay-close"
                  @click="showWindow.proPic=false"
                ><i class="iconfont">x</i></a>
                <div class="form_content">
                  <form id="proPicForm">
                    <div class="item">
                      <span class="label"><i class="require">*</i>项目图片</span>
                      <div class="item-box">
                        <input
                          v-model="formLogo.logoPath"
                          type="text"
                          disabled="disabled"
                        >
                        <span
                          class="button"
                          id="uploadImg"
                          @click="showImageWindow"
                        >添加图片</span>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="form_control">
                  <a
                    @click="showWindow.proPic = false"
                    href="javascript:;"
                    class="button close"
                    id="proPic_close"
                  >取消</a>
                  <a
                    @click="saveLogo"
                    href="javascript:;"
                    class="button"
                    id="proPic_submit"
                  >提交</a>
                </div>
              </div>
            </div>
            <div
              id="dialog_overlay"
              class=""
              :style="formatShowWindow(showWindow.proPicOption.proPicDialog)"
            >
              <div id="dialog_bg"></div>
              <div
                id="dialog_panel"
                style="margin-left: -137px; margin-top: -84px;"
                class=""
              >
                <div id="dialog_panel_bg"></div>
                <div id="dialog_title">选择图片</div>
                <div id="dialog_content">
                  <div
                    class="imgType"
                    style="margin-bottom:10px;"
                    id="imgType"
                  >允许上传的图片格式：jpg</div>
                  <div
                    id="thumbPreview"
                    v-show="showWindow.proPicOption.proPicImgPreview"
                  ><img
                      ref="previewImg"
                      :onerror="$store.state.defaultImg"
                    ></div>
                  <div>
                    <input
                      id="imageFile"
                      type="file"
                      accept="image/*"
                      ref="imageFile"
                      @change="imageFileChange"
                    >
                  </div>
                </div>
                <div id="dialog_control">
                  <a
                    href="javascript:void(0)"
                    @click="hideImageWindow"
                    id="dialog_close"
                    class="button"
                    style="display: inline-block;"
                  >取消</a>
                  <a
                    href="javascript:void(0)"
                    @click="confirmImage"
                    id="dialog_ok"
                    class="button"
                    style="display: inline-block;"
                  >确认</a>
                </div>
              </div>
            </div>
            <!-- 资源弹窗 -->
            <div
              class="form_overlay"
              :style="formatShowWindow(showWindow.brief2)"
            >
              <div class="form_overlay_bg"></div>
              <div
                class="form_panel editor"
                style=""
              >
                <div class="form_title">课程简介及课程特色</div>
                <a
                  href="javascript:void(0)"
                  class="overlay-close"
                  @click="showWindow.brief2 = false"
                ><i class="iconfont"></i></a>
                <div
                  class="form_content"
                  style=""
                >
                  <form
                    id="checkRequireForm"
                    style=""
                  >
                    <div
                      class="item"
                      style=""
                    >
                      <vue-ueditor-wrap
                        v-model="formCharacteristic.brief"
                        :config="editorConfig"
                        editor-id="editor-demo-1"
                      ></vue-ueditor-wrap>
                    </div>
                  </form>
                </div>
                <div class="form_control">
                  <a
                    href="javascript:;"
                    @click="showWindow.brief2 = false"
                    class="button close"
                    id="checkRequire_close"
                  >取消</a>
                  <a
                    href="javascript:;"
                    @click="saveBrief2"
                    class="button"
                    id="checkRequire_submit"
                  >提交</a>
                </div>
              </div>
            </div>
            <div
              class="form_overlay"
              :style="formatShowWindow(showWindow.references)"
            >
              <div class="form_overlay_bg"></div>
              <div
                class="form_panel editor"
                style=""
              >
                <div class="form_title">参考资料</div>
                <a
                  href="javascript:void(0)"
                  class="overlay-close"
                  @click="showWindow.references = false"
                ><i class="iconfont"></i></a>
                <div
                  class="form_content"
                  style=""
                >
                  <form
                    id="checkRequireForm"
                    style=""
                  >
                    <div
                      class="item"
                      style=""
                    >
                      <vue-ueditor-wrap
                        v-model="formReferences.references"
                        :config="editorConfig"
                        editor-id="editor-demo-5"
                      ></vue-ueditor-wrap>
                    </div>
                  </form>
                </div>
                <div class="form_control">
                  <a
                    href="javascript:;"
                    @click="showWindow.references = false"
                    class="button close"
                    id="checkRequire_close"
                  >取消</a>
                  <a
                    href="javascript:;"
                    @click="saveReferences"
                    class="button"
                    id="checkRequire_submit"
                  >提交</a>
                </div>
              </div>
            </div>
            <div
              class="form_overlay"
              :style="formatShowWindow(showWindow.questions)"
            >
              <div class="form_overlay_bg"></div>
              <div
                class="form_panel editor"
                style=""
              >
                <div class="form_title">常见问题</div>
                <a
                  href="javascript:void(0)"
                  class="overlay-close"
                  @click="showWindow.questions = false"
                ><i class="iconfont"></i></a>
                <div
                  class="form_content"
                  style=""
                >
                  <form
                    id="checkRequireForm"
                    style=""
                  >
                    <div
                      class="item"
                      style=""
                    >
                      <vue-ueditor-wrap
                        v-model="formQuestions.questions"
                        :config="editorConfig"
                        editor-id="editor-demo-6"
                      ></vue-ueditor-wrap>
                    </div>
                  </form>
                </div>
                <div class="form_control">
                  <a
                    href="javascript:;"
                    @click="showWindow.questions = false"
                    class="button close"
                    id="checkRequire_close"
                  >取消</a>
                  <a
                    href="javascript:;"
                    @click="saveQuestions"
                    class="button"
                    id="checkRequire_submit"
                  >提交</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'

export default {
  name: 'OnlineBasic',
  components: {
    VueUeditorWrap
  },
  data () {
    return {
      editorConfig: {
        UEDITOR_HOME_URL: '/UE/',
        serverUrl: this.$store.state.uEditorServerUrl,
        autoHeight: true,
        initialFrameWidth: '100%',
        initialFrameHeight: 300
      },
      formInfo: {
        title: '',
        logoPath: '',
        videoPath: '',
        subjectCategory_id: '',
        subject_id: '',
        isPub: '',
        lessonLang: '',
        otherSubject: [
          { txt: '' }
        ],
        lessonObj: {
          Obj1: false,
          Obj2: false,
          Obj3: false,
          Obj4: false,
          Obj5: false
        },
        allTime: '',
        startTime: '',
        endTime: '',
        grade: '',
        recommend: '',
        status: null
      },
      formBrief: {
        subjectCategory_id: '',
        subject_id: '',
        isPub: '',
        lessonLang: '',
        lessonObj: {
          Obj1: false,
          Obj2: false,
          Obj3: false,
          Obj4: false,
          Obj5: false
        },
        otherSubject: [
          { txt: '' }
        ],
        allTime: '',
        startTime: '',
        endTime: '',
        grade: '',
        recommend: ''
      },
      formLogo: {
        logoPath: ''
      },
      formVideo: {
        videoPath: ''
      },
      formCharacteristic: {
        brief: ''
      },
      formGoal: {
        goal: ''
      },
      formOutline: {
        outline: ''
      },
      formAppraise: {
        appraise: ''
      },
      formReferences: {
        references: ''
      },
      formQuestions: {
        questions: ''
      },
      showWindow: {
        brief: false,
        proPic: false,
        proPicOption: {
          proPicDialog: false,
          proPicImgPreview: false,
          uploaded_img: '',
          uploaded_name: ''
        },
        video: false,
        bigFile: false,
        bigFileOption: {
          showProgress: false,
          progressValue: 0
        },
        brief2: false,
        goal: false,
        outline: false,
        appraise: false,
        references: false,
        questions: false
      },
      categoryData: [],
      subjectData: [],
      resourcesInfo: {
        id: 0,
        title: '',
        page: 1,
        size: 10
      },
      resourcesData: [],
      resourcesCount: 0,
      sensitiveWord: []
    }
  },
  methods: {
    showRadio (v) {
      console.log(v)
    },
    formatNum(num, val) {
      var value = val ? val.length : 0
      return Number(num - value)
    },
    // 资源分页
    pageCalluser(data) {
      this.resourcesInfo.page = data
      this.getResources()
    },
    async getInfo(id) {
      const url = '/lesson_online/' + id + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo = data
        this.formInfo.lessonObj = this.formInfo.lessonObj ? JSON.parse(this.formInfo.lessonObj) : {}
        this.formInfo.otherSubject = this.formInfo.otherSubject ? JSON.parse(this.formInfo.otherSubject) : [{ txt: '' }]
      }).catch((error) => {
        console.log(error)
      })
    },
    addOtherSubject() {
      this.formBrief.otherSubject.push({ txt: '' })
    },
    delOtherSubject(i) {
      if (this.formBrief.otherSubject.length === 1) {
        this.$layer.msg('不可全部删除')
      } else {
        this.formBrief.otherSubject.splice(i, 1)
      }
    },
    // 搜索大类
    async searchCategory() {
      await this.$http.get('/subject_category/', {
        params: {
          page: 1,
          size: 1000
        }
      }).then((data) => {
        this.categoryData = data.results
      }).catch((error) => {
        console.log(error)
      })
    },
    // 搜索专业
    async getSubject(id) {
      this.subjectData = []
      this.formInfo.subject_id = ''
      await this.$http.get('/subject/', {
        params: {
          page: 1,
          size: 100000,
          subject_category_id: id
        }
      }).then((data) => {
        this.formBrief.subject_id = ''
        this.subjectData = data.results
      }).catch((error) => {
        console.log(error)
      })
    },
    // 查询资源列表
    async getResources() {
      await this.$http.get('/resource/', {
        params: this.resourcesInfo
      }).then((data) => {
        this.resourcesData = data.results
        this.resourcesCount = data.count
      }).catch(() => {
        this.$layer.msg('获取人员列表失败！')
      })
    },
    formatShowWindow(tag) {
      if (tag) {
        return {
          visibility: 'visible'
        }
      } else {
        return {}
      }
    },
    async openBrief() {
      this.showWindow.brief = true
      this.formBrief.isPub = this.formInfo.isPub
      this.formBrief.lessonLang = this.formInfo.lessonLang
      this.formBrief.subjectCategory_id = this.formInfo.subjectCategory_id
      if (this.formBrief.subjectCategory_id) {
        await this.getSubject(this.formBrief.subjectCategory_id)
      }
      this.formBrief.subject_id = this.formInfo.subject ? this.formInfo.subject.id : ''
      this.formBrief.lessonObj = { ...this.formInfo.lessonObj }
      this.formBrief.otherSubject = this.formInfo.otherSubject.length ? this.formInfo.otherSubject : [{ txt: '' }]
      this.formBrief.allTime = this.formInfo.allTime
      this.formBrief.startTime = this.formInfo.startTime
      this.formBrief.endTime = this.formInfo.endTime
      this.formBrief.grade = this.formInfo.grade ? parseFloat(this.formInfo.grade) : ''
      this.formBrief.recommend = this.formInfo.recommend ? this.formInfo.recommend : ''
    },
    async saveBrief() {
      if (parseInt(this.formBrief.isPub) !== 0 && parseInt(this.formBrief.isPub) !== 1) {
        this.$layer.msg('请选择是否公开课程！')
        return
      }
      if (!this.formBrief.lessonLang) {
        this.$layer.msg('请选择授课语种！')
        return
      }
      if (!this.formBrief.subjectCategory_id) {
        this.$layer.msg('请选择专业大类！')
        return
      }
      if (!this.formBrief.subject_id) {
        this.$layer.msg('请选择专业！')
        return
      }
      if (!this.formBrief.allTime) {
        this.$layer.msg('请输入总学时！')
        return
      }
      if (this.formBrief.allTime && this.formBrief.allTime.toString().split('.').length === 2 && this.formBrief.allTime.toString().split('.')[1].length > 2) {
        this.$layer.msg('总学时输入错误，小数部分不能超过2位！')
        return
      }
      if (!this.formBrief.startTime) {
        this.$layer.msg('请输入开始时间！')
        return
      }
      if (!this.formBrief.endTime) {
        this.$layer.msg('请输入结束时间！')
        return
      }
      if (this.formBrief.startTime > this.formBrief.endTime) {
        this.$layer.msg('开始时间不能大于结束时间！')
        return
      }
      if (!this.formBrief.grade) {
        this.$layer.msg('请输入学分！')
        return
      }
      if (this.formBrief.grade && this.formBrief.grade.toString().split('.').length === 2 && this.formBrief.grade.toString().split('.')[1].length > 2) {
        this.$layer.msg('总学时输入错误，小数部分不能超过2位！')
        return
      }
      if (this.formBrief.recommend) {
        const isRight = this.utils.getWords(this.formBrief.recommend, this.sensitiveWord)
        if (isRight) {
          this.$layer.msg('输入的内容有敏感词!')
          return false
        }
      }

      this.showWindow.brief = false
      this.formBrief.title = this.formInfo.title
      // this.formBrief.isPub = this.formBrief.isPub ? 1 : 0
      this.formBrief.lessonObj = JSON.stringify(this.formBrief.lessonObj)
      this.formBrief.otherSubject = JSON.stringify(this.formBrief.otherSubject)
      const url = '/lesson_online/' + this.formInfo.id + '/'
      await this.$http.put(url, this.formBrief).then((data) => {
        this.getInfo(this.$route.query.id)
        this.$layer.msg('提交成功！')
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    showImageWindow() {
      this.showWindow.proPicOption.proPicImgPreview = false
      this.showWindow.proPicOption.proPicDialog = true
    },
    hideImageWindow() {
      this.showWindow.proPicOption.proPicDialog = false
    },
    confirmImage() {
      this.formLogo.logoPath = this.showWindow.proPicOption.uploaded_img
      this.hideImageWindow()
    },
    openProPic() {
      this.formLogo.logoPath = this.formInfo.logoPath
      this.showWindow.proPic = true
    },
    async saveLogo() {
      this.formLogo.title = this.formInfo.title
      const url = '/lesson_online/' + this.formInfo.id + '/'
      await this.$http.put(url, this.formLogo).then((data) => {
        if (data.id) {
          this.formInfo.logoPath = this.formLogo.logoPath
          this.showWindow.proPic = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    async imageFileChange() {
      const uploadUrl = '/files/' + this.$refs.imageFile.files[0].name
      await this.$http.put(uploadUrl, this.$refs.imageFile.files[0]).then((data) => {
        this.showWindow.proPicOption.uploaded_img = data
        this.showWindow.proPicOption.uploaded_name = this.$refs.imageFile.files[0].name
        this.showWindow.proPicOption.proPicImgPreview = true
        this.$refs.previewImg.src = data
      }).catch(() => {
        this.$layer.msg('上传失败！')
      })
    },
    openVideo() {
      this.showWindow.video = true
    },
    showFileWindow() {
      this.showWindow.bigFile = true
      this.formVideo.videoPath = this.formInfo.videoPath
    },
    hideFileWindow() {
      this.showWindow.bigFile = false
    },
    async fileChange() {
      this.showWindow.bigFileOption.showProgress = true
      const fileRealName = this.$refs.docFile.files[0].name
      const uploadUrl = '/info_files/' + fileRealName
      await this.$http.put(uploadUrl, this.$refs.docFile.files[0], {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (e) => {
          this.showWindow.bigFileOption.progressValue = Math.ceil(e.loaded / e.total * 100)
        }
      }).then((data) => {
        this.showWindow.bigFileOption.showProgress = false
        this.showWindow.bigFileOption.progressValue = 0
        this.hideFileWindow()
        this.formVideo.videoPath = data
      }).catch(() => {
        this.showWindow.bigFileOption.showProgress = false
        this.showWindow.bigFileOption.progressValue = 0
        this.hideFileWindow()
        this.$layer.msg('上传失败！')
      })
    },
    async saveVideo() {
      this.formVideo.title = this.formInfo.title
      const url = '/lesson_online/' + this.formInfo.id + '/'
      await this.$http.put(url, this.formVideo).then((data) => {
        if (data.id) {
          this.formInfo.videoPath = this.formVideo.videoPath
          this.showWindow.video = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    async saveClearVideo() {
      const url = '/lesson_online/' + this.formInfo.id + '/'
      await this.$parent.showConfirm('是否确认要清除视频简介文件?', () => {
        this.$http.put(url, {
          videoPath: null,
          title: this.formInfo.title
        }).then((data) => {
          this.$parent.showMsg('清除成功！')
          this.formInfo.videoPath = ''
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('清除失败！')
        })
      })
    },
    showBrief2() {
      this.formCharacteristic.brief = this.formInfo.brief
      this.showWindow.brief2 = true
    },
    async saveBrief2() {
      this.formCharacteristic.title = this.formInfo.title
      const isRight = this.utils.getWords(this.formCharacteristic.brief, this.sensitiveWord)
      if (isRight) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      const url = '/lesson_online/' + this.formInfo.id + '/'
      await this.$http.put(url, this.formCharacteristic).then((data) => {
        if (data.id) {
          this.formInfo.brief = this.formCharacteristic.brief
          this.showWindow.brief2 = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    showGoal() {
      this.formGoal.goal = this.formInfo.goal
      this.showWindow.goal = true
    },
    async saveGoal() {
      this.formGoal.title = this.formInfo.title
      const url = '/lesson_online/' + this.formInfo.id + '/'
      await this.$http.put(url, this.formGoal).then((data) => {
        if (data.id) {
          this.formInfo.goal = this.formGoal.goal
          this.showWindow.goal = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    showOutline() {
      this.formOutline.outline = this.formInfo.outline
      this.showWindow.outline = true
    },
    async saveOutline() {
      this.formOutline.title = this.formInfo.title
      const url = '/lesson_online/' + this.formInfo.id + '/'
      await this.$http.put(url, this.formOutline).then((data) => {
        if (data.id) {
          this.formInfo.outline = this.formOutline.outline
          this.showWindow.outline = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    showAppraise() {
      this.formAppraise.appraise = this.formInfo.appraise
      this.showWindow.appraise = true
    },
    async saveAppraise() {
      this.formAppraise.title = this.formInfo.title
      const url = '/lesson_online/' + this.formInfo.id + '/'
      await this.$http.put(url, this.formAppraise).then((data) => {
        if (data.id) {
          this.formInfo.appraise = this.formAppraise.appraise
          this.showWindow.appraise = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    showReferences() {
      this.formReferences.references = this.formInfo.references
      this.showWindow.references = true
    },
    async saveReferences() {
      this.formReferences.title = this.formInfo.title
      const isRight = this.utils.getWords(this.formReferences.references, this.sensitiveWord)
      if (isRight) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      const url = '/lesson_online/' + this.formInfo.id + '/'
      await this.$http.put(url, this.formReferences).then((data) => {
        if (data.id) {
          this.formInfo.references = this.formReferences.references
          this.showWindow.references = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    showQuestions() {
      this.formQuestions.questions = this.formInfo.questions
      this.showWindow.questions = true
    },
    async saveQuestions() {
      this.formQuestions.title = this.formInfo.title
      const isRight = this.utils.getWords(this.formQuestions.questions, this.sensitiveWord)
      if (isRight) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      const url = '/lesson_online/' + this.formInfo.id + '/'
      await this.$http.put(url, this.formQuestions).then((data) => {
        if (data.id) {
          this.formInfo.questions = this.formQuestions.questions
          this.showWindow.questions = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    async clearItem(categgory) {
      await this.$parent.showConfirm('是否清空内容?', () => {
        switch (categgory) {
          case 'brief':
            this.formCharacteristic = {
              brief: ''
            }
            this.saveBrief2()
            break
          case 'goal':
            this.formGoal = {
              goal: ''
            }
            this.saveGoal()
            break
          case 'outline':
            this.formOutline = {
              outline: ''
            }
            this.saveOutline()
            break
          case 'appraise':
            this.formAppraise = {
              appraise: ''
            }
            this.saveAppraise()
            break
          case 'references':
            this.formReferences = {
              references: ''
            }
            this.saveReferences()
            break
          case 'questions':
            this.formQuestions = {
              questions: ''
            }
            this.saveQuestions()
            break
        }
      })
    },
    formatTerm(value) {
      var term = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九']
      let text = ''
      if (value) {
        if (value.toString().length === 1) {
          text = term[value]
        } else if (value.toString().length === 2) {
          text = term[value.toString()[0]] + '十' + term[value.toString()[1]]
        } else if (value.toString().length === 3) {
          text = term[value.toString()[0]] + '百' + term[value.toString()[1]] + '十' + term[value.toString()[2]]
        } else if (value.toString().length === 4) {
          text = term[value.toString()[0]] + '千' + term[value.toString()[1]] + '百' + term[value.toString()[2]] + '十' + term[value.toString()[2]]
        }
        return '第' + text + '学期'
      } else {
        return '-'
      }
    },
    // 获取敏感词
    async getSensitiveWord() {
      await this.$http.get('/sensitiveword/', {
        params: {
          page: 1,
          size: 10000,
          status: 1
        }
      }).then((data) => {
        if (data.results.length) {
          data.results.forEach(item => {
            if (item.words) {
              const wordList = item.words.split('\n')
              for (let i = 0; i < wordList.length; i++) {
                this.sensitiveWord.push(wordList[i])
              }
            }
          })
        } else {
          this.sensitiveWord = []
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  // 计算属性
  computed: {
    resourInfo() {
      return {
        page: this.resourcesInfo.page,
        all: Math.ceil(this.resourcesCount / this.resourcesInfo.size),
        totalData: this.resourcesCount
      }
    }
  },
  mounted() {
    this.searchCategory()
    this.getInfo(this.$route.query.id)
    this.getSensitiveWord()

    // window.scroll(0, 0)
  }
}
</script>

<style scoped src="../../../assets/css/project-detail.css"></style>
<style scoped src="../../../assets/css/table.css"></style>
<style scoped src="../../../assets/css/chunkUpload.css"></style>
<style scoped src="../../../assets/css/project-manage.css"></style>
<style scoped lang="less">
#center {
  margin-top: -42px;
}
#searchSection {
  height: auto;
}
.panel-content {
  padding: 0;
  background: #f5f5f5 !important;
  min-width: 1100px;
}
.center_content .title {
  border-bottom: none;
}
.box-wrap {
  display: flex;
  justify-content: start;
}
.lBox {
  flex-grow: 1;
}
.rBox {
  margin-left: 30px;
}
.center_content .titleA:before {
  background-color: #ffffff;
}
.imgCover {
  overflow: hidden;
  position: relative;
  background: #f8f8f8;
  img {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
}
#thumbPreview {
  height: auto;
  background: none;
}
#thumbPreview img {
  height: auto;
  background: none;
}
.detail {
  background: #f8f8f8;
  border-radius: 5px;
  padding: 10px 15px;
  margin-top: 10px;
  .item {
    display: flex;
    flex-wrap: wrap;
  }
  p {
    margin-right: 30px;
    line-height: 48px;
    span {
      color: #73D6CA;
    }
  }
}
.projectRecord {
  background: #ffffff;
  padding: 0 30px 10px;
  .upload {
    color: #ffffff;
    background: #0099ff;
    padding: 6px 12px;
    border-radius: 20px;
  }
}
.part-title {
  font-size: 16px;
  padding-left: 15px;
}
.part-title-video {
  .upload:nth-child(1) {
    position: absolute;
    right: 90px;
  }
  .upload:nth-child(2) {
    position: absolute;
    right: 0;
  }
}
.part-content {
  border: 1px solid #f0f0f0;
  padding: 20px;
  color: #666666;
  min-height: 110px;
  overflow: hidden;
}
#briefForm {
  .wrap {
    display: inline-block;
    margin-right: 15px;
  }
  .date {
    width: 302px;
    height: 32px;
  }
  .del {
    margin-left: 10px;
    font-size: 22px;
    color: #c7254e;
    cursor: pointer;
    margin: 0;
    background: transparent;
    top: 3px;
    position: relative;
  }
  .item-input {
    display: inline-block;
    width: 315px;
  }
  .addBtn {
    cursor: pointer;
    top: 10px;
    left: 110px;
    position: relative;
    width: 80px;
    height: 30px;
    line-height: 30px;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
    background: #aeaeae;
  }
}
.clearVideo {
  display: inline-block;
  position: relative;
  bottom: 5px;
  width: 309px;
  height: 36px;
  line-height: 36px;
  background: #646464;
  color: #ffffff;
  text-align: center;
}
.tips {
  span {
    display: block;
    margin-left: 110px;
    color: #e12d2d;
  }
}
.detail .des {
  line-height: 1.5;
}
</style>
